import React from "react";
import { Outlet } from "react-router-dom";
import HeaderBottom from "./header-bottom";
import HeaderTop from "./header-top";
import { Separator } from "@/components/ui/separator";
import Modal from "../base/modal";
import useQueryVendor from "@/hooks/queries/useQueryVendor";

const Layout: React.FC = () => {
  const { data: vendor } = useQueryVendor();

  return (
    <React.Fragment>
      <div>
        <HeaderTop vendor={vendor} />
        <Separator className="dark:bg-slate-200" />
        <HeaderBottom />
      </div>
      <div>
        <Outlet />
        <Modal />
      </div>
    </React.Fragment>
  );
};

export default Layout;
